<template>
  <b-card class="bg-transparent border-0">    
    <div class="row">
      <div class="col-md-11 d-flex align-items-center">        
      </div>
      <div class="col-md-1 d-flex align-items-center">
        <b-button v-if="!monitorMode"
                  id="btn-collapse-subtitle"
                  variant="link border-primary mt-3"
                  :title="$t('components.monitoring_filter.legenda')"
                  v-b-toggle.collapse-subtitle
                  v-b-tooltip
                  pill
                  style="margin-right: 8px;">
          <i class="fa fa-tags"/>
        </b-button>
        <b-button v-if="!monitorMode"
                  id="btn-collapse-filters"
                  variant="link border-primary mt-3"
                  :title="$t('components.monitoring_filter.filtros')"
                  v-b-toggle.collapse-filters
                  v-b-tooltip
                  pill
                  style="margin-right: 8px;">
          <i class="fas fa-search"/>
        </b-button>
        <b-button v-if="!monitorMode"
                  id="btn-monitor-mode"
                  variant="link border-primary mt-3"
                  :title="$t('components.monitoring_filter.modo_monitor')"
                  v-b-tooltip
                  pill
                  @click="$router.push({ query: { monitor: 'true' } })">
          <i class="fa fa-tv"/>
        </b-button>
      </div>
    </div>
    <b-collapse id="collapse-filters" class="mt-2" v-model="filtro.show">
      <div class="row">
        <form class="col-md-3" @submit="e => {e.preventDefault(); $emit('search')}">
          <b-form-group :label="$t('ordemResultado.filtro.vns')" label-for="filter-vns">
            <b-input id="filter-vns" v-model="filtro.vns_filter"/>
          </b-form-group>
        </form>
        <b-form-group :label="$t('ordemResultado.filtro.tipo_integracao')" class="col-md-3">
            <v-select v-model="filtro.integration_type" @input="selectIntegrationType()" :options="typeOptions"
                      :reduce="option => option.value" multiple/>  
        </b-form-group>
        <b-form-group v-if="isVEUS" :label="$t('ordemResultado.filtro.empresa')"
                      label-for="filter-company" class="col-md-3">
            <v-select v-model="filtro.company_filter" @input="selectCompany()" :options="companies"
                      :reduce="option => option.value"/>
        </b-form-group>
        <b-form-group :label="$t('ordemResultado.filtro.status')"
                      label-for="filter-status" class="col-md-3">
            <v-select v-model="filtro.status_filter" :options="statusFiltro"
                      :reduce="option => option.value"/>
        </b-form-group>
      </div>
      <div class="row">          
        <div class="col-md-2">
          <b-btn id="btn-filter"
                  variant="primary"
                  class="align-self-center mt-3 btn-block"
                  @click="$emit('search')">
            <i class="fas fa-search"/> {{ $t('ordemResultado.filtro.filtrar_button') }}
          </b-btn>
        </div>
        <div class="col-md-2">
          <b-btn variant="link" class="align-self-center mt-3 btn-block" @click="cleanFilters">
            <i class="fas fa-search-minus"/> {{ $t('ordemResultado.filtro.limpar_button') }}
          </b-btn>
        </div>
      </div>
    </b-collapse>

    <b-collapse id="collapse-subtitle" class="mt-2" :visible="monitorMode">
      <div class="row d-flex flex-fill">
        <b-overlay class="col-lg-12 text-center">          
          <vnsHexagonListSubtitle class="m-auto"
          :monitor-mode="monitorMode"
          :legendCountPrimary="this.legendCountPrimary"
          :legendCountSuccess="this.legendCountSuccess"
          :legendCountWarning="this.legendCountWarning"
          :legendCountDanger="this.legendCountDanger"
          :legendCountSecondary="this.legendCountSecondary" />
        </b-overlay>      
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import {hasPerfil} from '@/acl'
import {mapActions, mapGetters} from "vuex";
import vnsHexagonListSubtitle from "@/pages/vns/components/vnsHexagonListSubtitle";

export default {
  name: "MonitoringFilter",
  components: {
    vnsHexagonListSubtitle
  },
  props: {
    monitorMode: {
      type: Boolean,
      default: false
    },
    legendCountPrimary: {
      type: Number,
      default: 0
    },
    legendCountSuccess: {
      type: Number,
      default: 0
    },
    legendCountWarning: {
      type: Number,
      default: 0
    },
    legendCountDanger: {
      type: Number,
      default: 0
    },
    legendCountSecondary: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      companiesStore: 'corecompanies/all',
      filtro: 'monitoringFilter/all'
    }),
    companies() {
      return this.companiesStore.map((company) => {
        return {
          label: company.name,
          value: company.id
        }
      })
    },
    statusFiltro(){
      return [
        {
          label: this.$t('ordemResultado.filtro.status_filtro.todos'),
          value: ''
        },
        {
          label: this.$t('ordemResultado.filtro.status_filtro.novo'),
          value: 'primary'
        },
        {
          label: this.$t('ordemResultado.filtro.status_filtro.ativo'),
          value: 'success'
        },
        {
          label: this.$t('ordemResultado.filtro.status_filtro.desconectado'),
          value: 'warning'
        },        
        {
          label: this.$t('ordemResultado.filtro.status_filtro.analise'),
          value: 'secondary'
        },
        {
          label: this.$t('ordemResultado.filtro.status_filtro.offline'),
          value: 'danger'
        }
      ]
    }
  },
  data() {
    return {
      isVEUS: false,
      typeOptions: [
        {
          label: 'Automation',
          value: 'Automation'
        },
        {
          label: 'Display',
          value: 'Display'
        },
        {
          label: 'Generic',
          value: 'Generic'
        },
        {
          label: 'HIS',
          value: 'HIS'
        },
        {
          label: 'Label',
          value: 'Label'
        },
        {
          label: 'Link',
          value: 'Link'
        },
        {
          label: 'LIS',
          value: 'LIS'
        },
        {
          label: 'Quick',
          value: 'Quick'
        },
        {
          label: 'Temp',
          value: 'Temp'
        }
      ],
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/listAll',
      'monitoringFilter/setSpecific',
      'monitoringFilter/reset',
      'order/setPagination'
    ]),
    cleanFilters() {
      this['monitoringFilter/reset']()
      this.$emit('search')
    },
    async hasPerfil(perfil) {
      try {
        return await hasPerfil(perfil)
      } catch (e) {
        return false
      }
    },
    selectCompany() {
      this.$emit('search')
    },
    selectIntegrationType() {
      this.$emit('search')
    }
  },
  async mounted() {
    await this['corecompanies/listAll']({per_page: 500})
    this.isVEUS = await hasPerfil('root')
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker {
  width: 100%;
}
#collapse-filters{
  @media (max-width: 600px) {
    margin-left: 2rem!important;
    margin-right: 2rem!important;
    .ml-5, .mr-5{
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>
